import { AuthDebugPanel } from '@certara/common-react-components';

/**
 * Debug page for authentication. The implementation lives in
 * `common-react-components` so all React apps surface the same diagnostics
 * for both Okta and CAD.
 */
export function DebugAuth() {
  return <AuthDebugPanel title="Load — Authentication Debug" />;
}
